import { useEffect } from 'react';
import { generatePath, Navigate, Outlet } from 'react-router-dom';

import { commonActions } from '@store/common/common.slice';

import { RouteEnum } from '@enum/route.enum';
import { useRouteName } from '@hook/route/use-route-name.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { useLocalStorage } from '@hook/store/use-local-storage.hook';
import { useAuthorized } from '@hook/user/use-authorized.hook';
import { isExist, isString } from '@util/data/is-exist';

import { useResetStore } from './hooks/reset-store.hook';

const unprotectedRoutes = new Set([
  RouteEnum.Login.name,
  RouteEnum.LoginCallback.name,
  RouteEnum.LoginMfa.name,
  RouteEnum.SignUp.name,
  RouteEnum.SignUpVelory.name,
  RouteEnum.ForgotPassword.name,
  RouteEnum.NewPassword.name,
  RouteEnum.Verify.name,
  RouteEnum.Docs.name,
  RouteEnum.Explorer.name,
  RouteEnum.RequestInternalIntegration.name,
  RouteEnum.RequestExternalIntegration.name,
]);
const authRoutes = new Set([
  RouteEnum.Login.name,
  RouteEnum.LoginMfa.name,
  RouteEnum.LoginCallback.name,
  RouteEnum.SignUp.name,
  RouteEnum.SignUpVelory.name,
]);

export default () => {
  const dispatch = useStoreDispatch();
  const { isAuthorized, isNeedMfa } = useAuthorized();
  const routeName = useRouteName();
  const [codeInvite] = useLocalStorage<string>('invite');
  const invite = useStoreSelector((state) => state.common.data.invite);

  useResetStore();

  useEffect(() => void (isExist(codeInvite) && dispatch(commonActions.setInvite(codeInvite))), [codeInvite]);

  if (isNeedMfa && !isAuthorized && routeName !== RouteEnum.LoginMfa.name) {
    return <Navigate to={RouteEnum.LoginMfa.path} />;
  }

  if (!unprotectedRoutes.has(routeName) && !isAuthorized) {
    return <Navigate to={RouteEnum.Login.path} />;
  }

  if (isAuthorized && isString(invite)) {
    return (
      <Navigate
        to={generatePath(RouteEnum.Invite.path, {
          code: invite,
        })}
      />
    );
  }

  if (isAuthorized && authRoutes.has(routeName)) {
    return <Navigate to={RouteEnum.Dashboard.path} />;
  }

  return <Outlet />;
};
